<template>
  <div>
    <v-input placeholder="请输入购券订单编号"
             v-model="valueId"
             style="width:200px;display:inline-block"></v-input>
    <v-button type="primary"
              @click="handleSearch">查询</v-button>
    <el-table :data="tableData">
      <el-table-column prop="order_id"
                       label="订单编号">
      </el-table-column>
      <el-table-column prop="remark"
                       label="产品名称">
        <template slot-scope="scope">
          <span>{{scope.row.remark[0]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用情况">
        <template slot-scope="scope">
          <span>{{scope.row.state === 1&&scope.row.is_mark_refund?'未使用':'已使用'}}</span>
        </template>
      </el-table-column>
      <el-table-column width="80px" label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     v-if="scope.row.is_mark_refund"
                     @click="confirmRefund(scope.row,true)"
                     size="small">标记退款</el-button>
          <el-button type="text"
                     v-if="scope.row.is_refund"
                     @click="confirmRefund(scope.row,false)"
                     size="small">退款</el-button>
          <span v-show="!scope.row.is_mark_refund&&!scope.row.is_refund">-</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
// 200806145681206001j cff27be6c59c11ea9a8100163e009f55
export default {
  data () {
    return {
      valueId: '',
      refundVisible: false,
      refundAmount: '',
      balanceAmount: '',
      detailInfo: {},
      tableData: [],
      rejectMark: ''
    }
  },
  methods: {
    handleRefundMark (item) {
      this.detailInfo = item
      this.refundVisible = true
    },
    confirmRefund (item, isMark) {
      this.detailInfo = item
      let url, message
      if (isMark) {
        url = `/dev/mark_refund/coupon/${this.detailInfo.order_id}`
        message = '标记退款成功'
      } else {
        url = `/dev/refund/coupon/${this.detailInfo.order_id}`
        message = '退款成功'
      }
      axios.post(url)
        .then(res => {
          this.refundVisible = false
          if (res.data.code === 200) {
            this.$message({
              message: message,
              type: 'success'
            })
            this.handleSearch()
          }
        })
    },
    handleSearch () {
      if (this.valueId === '') {
        this.$message({
          message: '请输入查询条件',
          type: 'warning'
        })
        return
      }
      this.search()
    },
    search () {
      let url = `/dev/paid_offer/order/${this.valueId}`
      url = url + '?paid_group=coupon'
      axios.get(url)
        .then(res => {
          let arr = []
          arr.push({...res.data.order})
          this.tableData = [...arr]
        })
    }
  },
  created () {
    // this.handleSearch()
  }
}
</script>

<style scoped>
  .tips{
    width:70%;
    display: flex;
    justify-content: space-between
  }
  .tips-content {
    background-color: #FFFFFF;
    box-shadow: 0px 0px 10px #aaaaaa;
    width: 25%;
    height: 80px;
    display: flex;
    align-items: center;
    margin: 30px 0px;
  }
  .tips-content-bar{
    width: 5px;
    height: 80px;
    background-color: #49a9ee;
    margin-right: 20px;
  }

  #self-modal{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shopping/shopping.vue